import {useAtom} from 'jotai';
import {useEffect} from 'react';
import {useGA4WithParams} from '@/hooks/tracking';
import {mapActionModeAtom} from '@/map/atom';
import {MapActionTypes} from '@/map/enums';
import {ToolboxItemProps} from './';
import {ReactComponent as MenuIcon} from './assets/streetview.svg';
import {ToolboxItem} from './StyledComponents';

const mode = MapActionTypes.street;

export const StreetViewButton = (props: ToolboxItemProps) => {
  const [action, setActionMode] = useAtom(mapActionModeAtom);
  const active = action?.mode === mode;

  const tracking = useGA4WithParams();

  const handleClick = () =>
    setActionMode((prev) => {
      if (prev?.mode === mode) {
        return null;
      } else {
        tracking('roadview');
        return {mode};
      }
    });

  useEffect(() => {
    return () => {
      if (active) {
        setActionMode(null);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ToolboxItem {...props} active={active} onClick={handleClick}>
      <MenuIcon />
    </ToolboxItem>
  );
};
